module.exports = __webpack_public_path__ + "img/729d9b5.png";